import image50000 from '../../assets/faces/50000.jpg';
import image20000 from '../../assets/faces/20000.jpg';
import image10000 from '../../assets/faces/10000.jpg';
import image5000 from '../../assets/faces/5000.jpg';
import image2000 from '../../assets/faces/2000.jpg';
import image1000 from '../../assets/faces/1000.jpg';
import image500 from '../../assets/faces/500.jpg';
import image200 from '../../assets/faces/200.jpg';
import image100 from '../../assets/faces/100.jpg';
import image50 from '../../assets/faces/50.jpg';
import image20 from '../../assets/faces/20.jpg';
import image10 from '../../assets/faces/10.jpg';
import image5 from '../../assets/faces/5.jpg';
import image2 from '../../assets/faces/2.jpg';
import image1 from '../../assets/faces/1.jpg';

export default [
  { index: 0, display: '500 €', value: 500, image: image50000 },
  { index: 1, display: '200 €', value: 200, image: image20000 },
  { index: 2, display: '100 €', value: 100, image: image10000 },
  { index: 3, display: '50 €', value: 50, image: image5000 },
  { index: 4, display: '20 €', value: 20, image: image2000 },
  { index: 5, display: '10 €', value: 10, image: image1000 },
  { index: 6, display: '5 €', value: 5, image: image500 },
  { index: 7, display: '2 €', value: 2, image: image200 },
  { index: 8, display: '1 €', value: 1, image: image100 },
  { index: 9, display: '50 cents', value: 0.5, image: image50 },
  { index: 10, display: '20 cents', value: 0.2, image: image20 },
  { index: 11, display: '10 cents', value: 0.1, image: image10 },
  { index: 12, display: '5 cents', value: 0.05, image: image5 },
  { index: 13, display: '2 cents', value: 0.02, image: image2 },
  { index: 14, display: '1 cent', value: 0.01, image: image1 },
];
